import DropdownProvider from './DropdownProvider';
import { Outlet, useParams } from 'react-router-dom';

function DropdownLayout({ pageId: propPageId }) {
  const { pageId: paramPageId } = useParams();
  const pageId = propPageId || paramPageId;

  return (
    <DropdownProvider pageId={pageId}>
      <Outlet />
    </DropdownProvider>
  );
}

export default DropdownLayout;